import React, { useState, useEffect, useContext } from "react";
import { globalInfo } from "../../App";
import { useParams, Link } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import isEmail from "validator/lib/isEmail";
import {
  getCountriesDropdown,
  getStatesDropdowns,
  getRegionDropdown,
  getProfessionDropdown,
  getCategoryDropdown,
  onlyNumber,
} from "../../Utils/commonFunctions";
import { submitFormData } from "../../Utils/adminFunctions";
import { useNavigate } from "react-router-dom";
const AdminAddParticipant = () => {
  const { ip_address } = useContext(globalInfo);
  const { pgID } = useParams();
  //for dropdowns//
  const [listCountries, setListCountries] = useState([]);
  const [listStates, setListStates] = useState([]);
  const [listProfession, setListProfession] = useState([]);
  const [listRegion, setListRegion] = useState([]);
  const [listCategory, setListCategory] = useState([]);

  ////form input fields///
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [category, setCategory] = useState("");
  const [profession, setProfession] = useState("");
  const [region, setRegion] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [source, setSource] = useState("");

  const [errorFirstName, setErrorFirstName] = useState("");
  const [errorCategory, setErrorCategory] = useState("");
  const [errorProfession, setErrorProfession] = useState("");
  const [errorRegion, setErrorRegion] = useState("");
  const [errorCountry, setErrorCountry] = useState("");
  const [errorState, setErrorState] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [errorSource, setErrorSource] = useState("");
  const navigate = useNavigate() // use navigate instance
  useEffect(() => {
    getRegion();
    getCategory();
  }, []);
  const getRegion = async () => {
    const response = await getRegionDropdown();
    if (response.status == "success") {
      setListRegion(response.optionItems);
    } else {
      setListRegion([]);
    }
  };
  const getCountries = async (region_id) => {
    const response = await getCountriesDropdown(region_id);
    if (response.status == "success") {
      setListCountries(response.optionItems);
    } else {
      setListCountries([]);
    }
  };
  const getCategory = async () => {
    const response = await getCategoryDropdown();
    if (response.status == "success") {
      setListCategory(response.optionItems);
    } else {
      setListCategory([]);
    }
  };
  const getProfession = async (categoryID) => {
    const response = await getProfessionDropdown(categoryID);
    if (response.status == "success") {
      setListProfession(response.optionItems);
    } else {
      setListProfession([]);
    }
  };

  const getStates = async (countryID) => {
    if (countryID !== "") {
      const response = await getStatesDropdowns(countryID);
      if (response.status == "success") {
        setListStates(response.optionItems);
      } else {
        setListStates([]);
      }
    } else {
      setListStates([]);
    }
  };

  const submitParticipant = async () => {
    let errorRequiredFiled = 0;

    if (firstName === "") {
      setErrorFirstName("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (category === "") {
      setErrorCategory("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (profession === "") {
      setErrorProfession("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (region === "") {
      setErrorRegion("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (country === "") {
      setErrorCountry("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (state === "") {
      setErrorState("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (email === "") {
      setErrorEmail("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (source === "") {
      setErrorSource("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (errorRequiredFiled > 0) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      return false;
    }

    if (isEmail(email) === false) {
      setErrorEmail("Incorrect email format");
      toast.warning("Incorrect email format ", { autoClose: 1500 });
      return false;
    }
    const bodyFormData = new FormData();
    bodyFormData.append("first_name", firstName);
    bodyFormData.append("last_name", lastName);
    bodyFormData.append("category_id", category);
    bodyFormData.append("profession_id", profession);
    bodyFormData.append("region_id", region);
    bodyFormData.append("country_id", country);
    bodyFormData.append("state_id", state);
    bodyFormData.append("city", city);
    bodyFormData.append("zip_code", zipCode);
    bodyFormData.append("email", email);
    bodyFormData.append("contact", phone);
    bodyFormData.append("source", source);
    bodyFormData.append("entered_by_ip", ip_address);
    bodyFormData.append("participant_group_id", pgID);
    const response = await submitFormData("addParticipant", bodyFormData);
    if (response.status == "success") {
      setFirstName("");
      setLastName("");
      setCategory("");
      setProfession("");
      setRegion("");
      setCountry("");
      setState("");
      setCity("");
      setZipCode("");
      setEmail("");
      setPhone("");
      setSource("");
      setListStates([]);
      //navigate(`/AdminListParticipants/${pgID}`); // navigate to previous page after success
      toast.success(response.message, { autoClose: 1500 });
      navigate(`/AdminListParticipants/${pgID}`);
    } else {
      toast.error(response.message, { autoClose: 1500 });
    }
  };
  const phonNumberValidation = (number) => {
    const value = onlyNumber(number);
    setPhone(value);
  };
  return (
    <div>
      <div className="wrapper">
        <div>
          <ToastContainer></ToastContainer>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-default">
                      <div className="card-header">
                        <div className="card-tools">
                          <div className="col-md-12">
                            <Link
                              to={"/AdminListParticipants/" + pgID}
                              className="btn btn-sm custom-btn-primary"
                            >
                              <i className="fa fa-arrow-left"></i> Back
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                First Name<i className="text-danger">*</i>
                              </span>
                              <input
                                type="text"
                                className={
                                  "form-control" +
                                  (errorFirstName ? " is-invalid" : "")
                                }
                                placeholder="First Name"
                                value={firstName}
                                onChange={(e) => {
                                  setFirstName(e.target.value);
                                  setErrorFirstName("");
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Last Name
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Last Name"
                                value={lastName}
                                onChange={(e) => {
                                  setLastName(e.target.value);
                                }}
                              />
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Category<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control" +
                                  (errorCategory ? " is-invalid" : "")
                                }
                                value={category}
                                onChange={(e) => {
                                  getProfession(e.target.value);
                                  setCategory(e.target.value);
                                  setErrorCategory("");
                                }}
                              >
                                <option value="">Select</option>
                                {listCategory}
                              </select>
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Specialization<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control" +
                                  (errorProfession ? " is-invalid" : "")
                                }
                                value={profession}
                                onChange={(e) => {
                                  setProfession(e.target.value);
                                  setErrorProfession("");
                                }}
                              >
                                <option value="">Select</option>
                                {listProfession}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Region<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control" +
                                  (errorRegion ? " is-invalid" : "")
                                }
                                value={region}
                                onChange={(e) => {
                                  getCountries(e.target.value);
                                  setRegion(e.target.value);
                                  setErrorRegion("");
                                }}
                              >
                                <option value="">Select</option>
                                {listRegion}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Country<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control" +
                                  (errorCountry ? " is-invalid" : "")
                                }
                                value={country}
                                onChange={(e) => {
                                  getStates(e.target.value);
                                  setCountry(e.target.value);
                                  setErrorCountry("");
                                }}
                              >
                                <option value="">Select</option>
                                {listCountries}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                State<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control" +
                                  (errorState ? " is-invalid" : "")
                                }
                                value={state}
                                onChange={(e) => {
                                  setState(e.target.value);
                                  setErrorState("");
                                }}
                              >
                                <option value="">Select</option>
                                {listStates}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                City
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="City"
                                value={city}
                                onChange={(e) => {
                                  setCity(e.target.value);
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Zip/Postal Code
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Zip/Postal Code"
                                value={zipCode}
                                onChange={(e) => {
                                  setZipCode(e.target.value);
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Email<i className="text-danger">*</i>
                              </span>
                              <input
                                type="text"
                                className={
                                  "form-control" +
                                  (errorEmail ? " is-invalid" : "")
                                }
                                placeholder="Email"
                                value={email}
                                onChange={(e) => {
                                  setEmail(e.target.value);
                                  setErrorEmail("");
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Phone
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Phone"
                                value={phone}
                                onChange={(e) => {
                                  phonNumberValidation(e.target.value);
                                }}
                                maxLength={12}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Source<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control" +
                                  (errorSource ? " is-invalid" : "")
                                }
                                value={source}
                                onChange={(e) => {
                                  setSource(e.target.value);
                                  setErrorSource("");
                                }}
                              >
                                <option value="">Select</option>
                                <option value="Public">Public</option>
                                <option value="Private">Private</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <button
                              type="button"
                              className="btn btn-sm custom-btn-primary pull-right"
                              onClick={submitParticipant}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminAddParticipant;
